/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';

import styles from './testOverview.scss';
import securityService from '../../services/SecurityService';
import StartTestComponentButton from './StartTestComponentButton';
import parentTestService from '../../services/ParentTestService';
import apiService from '../../services/api/ApiService';

class DayCodeVerifier extends React.Component {
    static propTypes = {
        test: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            passwordCorrect: false,
        };
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.validateBeforeStartTest = this.validateBeforeStartTest.bind(this);
    }

    handlePasswordChange = (e) => {
        const { test } = this.props;
        const passwordCorrect = securityService.verifyDayCode(e.target.value, test.dayCode);

        this.setState({ passwordCorrect });
    };

    onFormSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        this.validateBeforeStartTest();
    }

    validateBeforeStartTest() {
        const { test } = this.props;
        const { passwordCorrect } = this.state;
        if (passwordCorrect) {
            this.validateDayCode().then(() => {
                parentTestService.startChildTestAndNavigate(test.assessmentRunId, test.orderNumber >= 1);
            });
        }
    }

    validateDayCode() {
        const { test } = this.props;
        const password = this.passwordInput.value;
        return apiService.validateDayCode(test.assessmentRunId, password);
    }

    render() {
        const { test } = this.props;
        const { passwordCorrect } = this.state;
        return (
            <div className={`${styles.actionBox} ${styles.current}`}>
                <form onSubmit={this.onFormSubmit}>
                    <div className={styles.dayCodeVerifier}>
                        <i className="fa fa-lock" aria-hidden />&nbsp;
                        <label htmlFor="day-code-input">{t('childTest.dayCodeLabel')}</label>
                        <input
                            className={styles.passwordInput}
                            id="day-code-input"
                            type="password"
                            name="dayCode"
                            onChange={this.handlePasswordChange}
                            ref={(element) => { this.passwordInput = element; }}
                        />
                    </div>
                    <StartTestComponentButton
                        startComponentAction={this.validateBeforeStartTest}
                        passwordCorrect={passwordCorrect}
                        title={test.title}
                    />
                </form>
            </div>
        );
    }
}

export default DayCodeVerifier;
